import React from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';

import SummarizeIcon from '@mui/icons-material/Summarize';
import {
          
          Box,
          Typography,
          Alert,
          TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          Collapse,
          Button,
          Dialog, DialogContent, DialogActions, 
        } from '@mui/material';
  

function Row(props) {
  const { object } = props;
  const [open, setOpen] = React.useState(false);

  // let json_new1 =  object.pre_permiso.replace(/[']/g,'"').replace(/None/gi,'null').replace(/True/gi,'true').replace(/False/gi,'false').replace(/\\n/gi,'')
  // console.log(json_new1)
  // var json_input1 = JSON.parse(json_new1);
  

  
  // let json_new2 =  object.post_permiso.replace(/[']/g,'"').replace(/None/gi,'null').replace(/True/gi,'true').replace(/False/gi,'false').replace(/\\n/gi,'')
  // console.log(json_new2)
  // var json_input2 = JSON.parse(json_new2);
  

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>
          <Typography variant='caption'>
            {(new Date(object.updated_at)).toLocaleString('es-CL')}
          </Typography>
        </TableCell>
        <TableCell>
          {object.user? object.user:''}
        </TableCell>
        <TableCell>
          <Typography variant='caption'>
            {object.ip?object.ip:''}
          </Typography>
        </TableCell>
        <TableCell>

        <Typography variant='caption'>
            {object.action?object.action:''}
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Typography color='primary' variant='overline'>Parámetros de modificación</Typography>
            <Box pl={5} sx={{ margin: 1, border:'1px solid #DDD', maxWidth:'100%'  }}>
                <pre sx={{maxInlineSize:'100%'}}>{object.json_request}</pre>
            </Box>
            <Typography color='primary' variant='overline'>Pre Json</Typography>
            <Box pl={5} sx={{ margin: 1, border:'1px solid #DDD', fontSize:'9px', maxWidth:'100%' }}>
                {object.pre_permiso}
            </Box>
            <Typography color='primary' variant='overline'>Post Json</Typography>
            <Box pl={5} sx={{ margin: 1 , border:'1px solid #DDD', fontSize:'9px', maxWidth:'100%'}}>
                {object.post_permiso}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


class LogsPermiso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],
      dialog:{
        open:false,
      }
    };

    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

  }

  openDialog(index){
    this.setState(prevState=>({
      dialog:{...prevState.dialog,
        open:true,
      }
      }),()=>{

    })
  }
  closeDialog(){
    this.setState({dialog:{open:false}},()=>{
    })
  }

  componentDidMount(){
    if(this.props.logs){
      this.setState({objects:this.props.logs?this.props.logs:[]},()=>{
        // console.log(this.props)
      });
    }
  }
  componentDidUpdate(prevProps){

    
    // console.log(this.props,prevProps)
      
      const matches = (obj, source) =>
        Object.keys(source).every(key => obj.hasOwnProperty(key) && obj[key] === source[key]);
    
      if( this.props.logs && (
            !matches(this.props.logs, prevProps.logs) || 
            (this.props.logs.length>0 && prevProps.logs.length===0) ||
            (!this.props.logs.length===0 && prevProps.logs.length>0)
          )
        ){
        this.setState({objects: this.props.logs?this.props.logs:[]},()=>{
          // console.log(this.state)
        });
      }
    
  }

  render() {
    return (
      
    <Box>

      {this.state.objects.length > 0 &&
      <Box>
        <Box>
          <Box>
            <Button onClick={this.openDialog} variant='outlined' startIcon={<SummarizeIcon/>} variant='contained'>
              Ver historial de modificaciones
            </Button>
          </Box>
        </Box>



        <Dialog open={this.state.dialog.open}
                onClose={this.closeDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={false} >
          <DialogContent>
            {this.state.objects.length>0 &&
            <Box p={1}>

              <TableContainer>
                <Table size="small" >
                  <TableHead>
                    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

                      <TableCell>
                        Detalles
                      </TableCell>
                      <TableCell>
                        Fecha y hora modificación
                      </TableCell>
                      <TableCell>
                        Usuario is
                      </TableCell>
                      <TableCell>
                        IP origen
                      </TableCell>
                      <TableCell>
                        Acción
                      </TableCell>
                    </TableRow>

                  </TableHead>

                  <TableBody>
                  {this.state.objects.map((object) => {
                    return(
                      <Row key={object.id} object={object} />
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            
            {this.state.objects.length===0 && 
            <Box>
              <Box p={1}>
                <Alert severity='warning'>
                  No hay registro de cambios
                </Alert>
              </Box>
            </Box>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} color="secondary">
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      }
    </Box>

    );
  }
}

export default LogsPermiso;
